import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  button: {
    fontSize: tokens.fontSizeBase400,
    color: tokens.colorBrandForeground1,
    ...shorthands.padding("0px", "0px", "0px", "0px"),
    width: "fitContent",
    minWidth: "none",
    ...shorthands.overflow("visible"),
  },
  container: {
    display: "flex",
    flexDirection: "column",
    ...shorthands.gap("12px"),
    "@media (min-width: 500px)": {
      width: "281px",
      ...shorthands.padding("12px", "0px", "12px", "12px"),
    },
  },
  image: {
    maxHeight: "160px",
    objectFit: "cover",
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    "@media (min-width: 500px)": {
      width: "241px",
      height: "112px",
    },
  },
  column: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "align-start",
    alignItems: "align-start",
    "@media (min-width: 500px)": {
      width: "100%",
      height: "auto",
      minHeight: "30px",
    },
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  disclaimerBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    ...shorthands.border("2px", "solid", tokens.colorNeutralBackground4),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
  },
  disclaimerHeading: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightMedium,
    color: tokens.colorNeutralForeground2,
    ...shorthands.margin("5px", "0px", "3px", "11px"),
  },
  disclaimerTextContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    ...shorthands.margin("0px", "0px", "10px", "0px"),
  },
  disclaimerText: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground4,
    ...shorthands.margin("0px", "5px", "0px", "11px"),
    lineHeight: "1.6",
    wordBreak: "break-word",
    whiteSpace: "normal",
    display: "block",
    columnCount: 1,
    columnWidth: "auto",
    columnGap: 0,
    // stack children as normal blocks
    "&& p": {
      display: "block !important", // wmde sets p { display:flex }
      width: "100%",
      breakInside: "avoid",
      WebkitColumnBreakInside: "avoid",
      MozColumnBreakInside: "avoid",
    },
    "&& strong": {
      display: "inline",
      fontWeight: 700,
    },
    "&& b": {
      display: "inline",
      fontWeight: 700,
    },
    "&& em": {
      display: "inline",
      fontStyle: "italic",
    },
    "&& i": {
      display: "inline",
      fontStyle: "italic",
    },
    "&& a": {
      display: "inline",
      color: "#0078d4",
      wordBreak: "break-word",
    },
  },
  hours: {
    color: tokens.colorNeutralForeground4,
  },
  leftSide: {
    justifyContent: "flex-start",
  },
  rightSide: {
    justifyContent: "flex-end",
  },
  hourBtn: {
    display: "block",
    "@media (min-width: 500px)": {
      display: "none",
    },
  },
  mealContainer: {
    display: "none",
    "@media (min-width: 500px)": {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      ...shorthands.gap("8px"),
    },
  },
  containerMealText: {
    fontWeight: "600",
    width: "40%",
  },
  containerTimingText: {
    fontWeight: "400",
    width: "60%",
    textAlign: "right",
  },
});
